import store, { actions } from "../../redux";
import { LikesProps } from "../../redux/slices/likes/Likes";
import { API_INSTANCES } from "../api_instance";
import { handleError } from "../errors";

const dispatch = store.dispatch;
const dislikeAPost = (payload: LikesProps.dislikeAPostPayload) => {
  API_INSTANCES.POST_LIKES.dislikeAPost(payload)
    .then((response) => {
      const data = response.data as LikesProps.dislikeAPostResponse;
      dispatch(actions.newsfeed.updateLikesCountForAPost({ ...data, ...payload }));

      const { post_id } = payload;
      dispatch(actions.newsfeed.setIsUserLiked({ post_id, voteType: "disliked" }));
    })
    .catch((error) => handleError(error, "dislikeAPost"));
};

const likeAPost = (payload: LikesProps.likeAPostPayload) => {
  API_INSTANCES.POST_LIKES.likeAPost(payload)
    .then((response) => {
      const data = response.data as LikesProps.likeAPostResponse;
      dispatch(actions.newsfeed.updateLikesCountForAPost({ ...data, ...payload }));

      const { post_id } = payload;
      dispatch(actions.newsfeed.setIsUserLiked({ post_id, voteType: "liked" }));
    })
    .catch((error) => handleError(error, "likeAPost"));
};

const getLikesAndDislikesCountForAPost = (
  payload: LikesProps.getLikesAndDislikesCountForAPostPayload
) => {
  API_INSTANCES.POST_LIKES.getLikesAndDislikesCountForAPost(payload)
    .then((response) => {
      const data =
        response.data as LikesProps.getLikesAndDislikesCountForAPostResponse;
      dispatch(actions.newsfeed.updateLikesCountForAPost({ ...data, ...payload }));
    })
    .catch((error) => handleError(error, "getLikesAndDislikesCountForAPost"));
};

const removeLikeOrDislikeForAPost = (
  payload: LikesProps.removeLikeOrDislikeForAPostPayload
) => {
  API_INSTANCES.POST_LIKES.removeLikeOrDislikeForAPost(payload)
    .then((response) => {
      const data =
        response.data as LikesProps.removeLikeOrDislikeForAPostResponse;
      dispatch(actions.newsfeed.updateLikesCountForAPost({ ...data, ...payload }));

      const { post_id } = payload;
      dispatch(actions.newsfeed.setIsUserLiked({ post_id, voteType: "none" }));
    })
    .catch((error) => handleError(error, "removeLikeOrDislikeForAPost"));
};

export const POST_LIKES = {
  likeAPost,
  dislikeAPost,
  getLikesAndDislikesCountForAPost,
  removeLikeOrDislikeForAPost,
};
